import React from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';

import './_separatorVertical.scss';

const SeparatorVertical = ({ dark, className = '' }) => {
  const separatorClass = c('vertical-separator', { 'dark': dark }, className);

  return (
    <div className={separatorClass} />
  );
};

SeparatorVertical.propTypes = {
  dark: PropTypes.bool,
  className: PropTypes.string
};

export default SeparatorVertical;
